import { cva } from "class-variance-authority";

export const registrationFeedbackNpsRootStyles = cva([
  "flex w-full flex-col items-stretch gap-6 text-left",
  "md:items-center md:gap-8 md:text-center",
]);

export const registrationFeedbackNpsHeaderStyles = cva([
  "flex w-full flex-col items-start gap-6 text-left",
  "md:items-center md:text-center",
]);

export const registrationFeedbackNpsTitleStyles = cva([
  "m-0 font-[Canela_Text,serif] text-[32px] font-black leading-normal tracking-[0.1px] text-[#1B1C1D]",
  "md:text-[40px]",
]);

export const registrationFeedbackNpsQuestionStyles = cva([
  "m-0 max-w-[640px] font-[Poppins,sans-serif] text-sm font-normal leading-5 tracking-[0.5px] text-[#1B1C1D]",
  "md:text-base md:leading-6",
]);

export const registrationFeedbackNpsScaleSectionStyles = cva([
  "flex w-full flex-col gap-3",
]);

export const registrationFeedbackNpsActionsStyles = cva([
  "flex w-full max-w-none flex-col items-center gap-4",
  "md:max-w-[476px]",
]);

export const registrationFeedbackMaybeLaterStyles = cva([
  "border-0 bg-transparent p-0 text-center",
  "font-[Poppins,sans-serif] text-sm font-medium leading-5 tracking-[0.1px] text-[#35CCBA]",
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2",
  "cursor-pointer",
]);
